import NumberUnit from '@exodus/currency';

const fiatFormatterOptions = {
  style: 'currency',
  currency: 'USD',
  currencyDisplay: 'narrowSymbol',
  minimumFractionDigits: 2,
} satisfies Intl.NumberFormatOptions;

const fiatFormatter = new Intl.NumberFormat('en-US', {
  ...fiatFormatterOptions,
  maximumFractionDigits: 2,
});
const fiatFormatterSmall = new Intl.NumberFormat('en-US', {
  ...fiatFormatterOptions,
  maximumSignificantDigits: 1,
});

export function formatFiat(value: NumberUnit | number | null) {
  if (value === null) {
    return '$-.--';
  }

  const numericalValue =
    value instanceof NumberUnit ? value.toDefaultNumber() : value;

  const small = numericalValue > 0 && numericalValue < 0.01;
  const formatter = small ? fiatFormatterSmall : fiatFormatter;

  return formatter.format(numericalValue);
}

const percentageFormatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatPercentage(value: number | null) {
  if (value === null) {
    return '-.--%';
  }

  return `${value >= 0 ? '+' : ''}${percentageFormatter.format(value)}`;
}

export function formatCrypto(value: number, symbol?: string): string {
  const cryptoFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4, // Simplified for the mocks, should be dynamic based on token.
  });

  return `${cryptoFormatter.format(value)}${symbol ? ` ${symbol}` : ''}`;
}
